(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbContentTypeGroupsConfig', [ContentTypeGroupsConfigDirective])
		.controller('ContentTypeGroupsConfigController', [
			'$mdDialog',
			'pxAuthService',
			'sbToastService',
			'gettextCatalog',
			'pxProgressService',
			'smbToolbarService',
			'smbIconTypes',
			'smbContentTypeGroupsConfigDataStore',
			'smbDeleteDialogService',
			ContentTypeGroupsConfigController
		]);

	var templateUrl = require('./contentTypeGroupsConfig.template');
	function ContentTypeGroupsConfigDirective() {
		return {
			restrict: 'E',
			controller: ContentTypeGroupsConfigController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {}
		};
	}

	function ContentTypeGroupsConfigController($mdDialog, pxAuthService, sbToastService, gettextCatalog, pxProgressService, smbToolbarService, smbIconTypes, smbContentTypeGroupsConfigDataStore, smbDeleteDialogService) {
		smbToolbarService.set(gettextCatalog.getString('Document Groups Configuration'), 'content.home', false, false);

		var vm = this;
		vm.iconType = smbIconTypes[smbIconTypes.SVG];
		vm.contentTypeGroupsDataStore = smbContentTypeGroupsConfigDataStore;
		vm.deleteContentTypeGroup = deleteContentTypeGroup;

		pxProgressService.visible = true;
		vm.contentTypeGroupsDataStore
			.loadGroups()
			.finally(function () { 
				pxProgressService.visible = false; 
			});

		function deleteContentTypeGroup(event, group) {
			var title = gettextCatalog.getString('Delete Document Type Group');
			var message = gettextCatalog.getString('Would you like to delete "{{typeName}}"? Deleting this group will permanently deleted all related types and documents, and can\'t be undone!', { 
				typeName: group.name 
			});
			
			smbDeleteDialogService
				.show(event, title, message)
				.then(function () {
					pxProgressService.visible = true;
					smbContentTypeGroupsConfigDataStore
						.deleteGroup(group.id)
						.then(function () {
							sbToastService.showSimple(gettextCatalog.getString('{{groupName}} was deleted!', { groupName: group.name }));
						})
						.catch(function () {
							sbToastService.showSimple(gettextCatalog.getString('Unable to delete group'));
						})
						.finally(function () {
							pxProgressService.visible = false;
						});
				}, angular.noop);
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/contentTypeGroupsConfig/contentTypeGroupsConfig.js
// module id = 73
// module chunks = 1